import Joyride from 'react-joyride'

import { GuideTourTooltip } from './Tooltip'
export const GuideTour = ({ steps = [], children, ...rest }) => (
  <Joyride
    run
    steps={steps}
    continuous
    styles={{
      options: {
        primaryColor: 'var(--color-primary)'
      }
    }}
    locale={{
      back: 'Voltar',
      close: 'Fechar',
      last: 'Anterior',
      next: 'Próxima',
      open: 'Abrir',
      skip: 'Pular'
    }}
    tooltipComponent={GuideTourTooltip}
    {...rest}
  />
)
